import axios from "axios";
import React, { useEffect, useState } from "react";
import { FallingLines } from "react-loader-spinner";
import { base_url } from "../../utils/AxiosConfig";
import { IoIosAddCircleOutline } from "react-icons/io";
import { FaEye } from "react-icons/fa6";
import AddPayroll from "./AddPayroll";
import ViewPayroll from "./ViewPayroll";
import { LuPanelLeftOpen, LuPanelRightOpen } from "react-icons/lu";

const Payroll = () => {


  const storedUserDataArray = JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
  let companyCode = null

  if (storedUserDataArray) {
    companyCode = storedUserDataArray[0].cmpcode
  }

  const [data, setData] = useState();
  const [popUpData, setpopUpData] = useState();
  const [Open, setOpen] = useState(false);
  const [reset, setReset] = useState(false);
  const [loader, setLoader] = useState(true);

  const [loadPayroll, setLoadPayroll] = useState(false)


  // pagination
  const [currentPage, SetcurrentPage] = useState(1);
  const recordsPerPage = 10;
  const lastIndex = currentPage * recordsPerPage;
  const firstIndex = lastIndex - recordsPerPage;
  const records = data?.slice(firstIndex, lastIndex);
  const npage = Math.ceil(data?.length / recordsPerPage);
  const numbers = Array.from({ length: npage }, (_, i) => i + 1);

  useEffect(() => {
    if (data) {
      setLoader(false);
    }
  }, [data]);
  useEffect(() => {
    const getData = async () => {
      try {
        const response = await axios.get(
          `${base_url}/api/PersonalInfoList/${companyCode}/ALL/YES/ALL/ALL/ALL/ALL`
        );
        if (response?.data) {
          setData(response.data);

          setReset(false);
        }
      } catch (error) {
        console.error('PersonalInfoListEerror:', error);
      }
    };

    getData();
  }, []);

  const setPayrollData = (data) => {
    setpopUpData('')
    if (data) {
      setpopUpData(data)
    }
  }


  useEffect(() => {
    if (popUpData) {
      console.log('setPayrollLoadEffect')
      setLoadPayroll(true)
    }
  }, [popUpData])

  // console.log('popUpData',popUpData)

  return (
    <div className="container">
      <div className="container-fluid">
        <div className="flex justify-between items-center">
          <div className="">
            <h6 className="text-2xl mb-4 font-bold text-gray-600 flex  justify-start items-center">
                Payroll Additions & Deductions
            </h6>  
          </div>
          <div className="mb-4">
            {Open === true ? <>< LuPanelRightOpen onClick={() => setOpen(false)} /></> : null}
            {Open === false ? <><LuPanelLeftOpen onClick={() => setOpen(true)} /></> : null}


          </div>
        </div>

        <div className={Open ? "table scroll h-auto" : "table scroll h-auto"} style={{ maxHeight: "450px" }}>
          {records ? (
            <>
              <table className="table-auto w-full text-xs border-collapse border border-gray-300 shadow-sm rounded-md">
                <thead>
                  <tr className="bg-[#F3F4F6] text-left text-gray-700">
                    <th className="px-1 py-1 bg-gray-200 border font-normal">Si No</th>
                    <th className="px-1 py-1 bg-gray-200 border font-normal">Emp ID</th>
                    <th className="px-1 py-1 bg-gray-200 border font-normal">Alternate ID</th>
                    <th className="px-1 py-1 bg-gray-200 border font-normal">Status</th>
                    <th className="px-1 py-1 bg-gray-200 border font-normal">Name</th>
                    <th className="px-1 py-1 bg-gray-200 border font-normal">Job Title</th>
                    <th className="px-1 py-1 bg-gray-200 border font-normal">Division</th>
                    <th className="px-1 py-1 bg-gray-200 border font-normal">Grade</th>
                    <th className="px-1 py-1 bg-gray-200 border font-normal">Gender</th>
                    <th className="px-1 py-1 bg-gray-200 border font-normal">Nationality</th>

                    {Open && (
                      <>
                        <th className="px-1 py-1 font-normal bg-gray-200 border">Bank Account</th>
                        <th className="px-1 py-1 font-normal bg-gray-200 border">Bank Name</th>
                        <th className="px-1 py-1 font-normal bg-gray-200 border">Agent ID</th>
                        <th className="px-1 py-1 font-normal bg-gray-200 border">Current Address</th>
                        <th className="px-1 py-1 font-normal bg-gray-200 border">Home Address</th>
                        <th className="px-1 py-1 font-normal bg-gray-200 border">Home Airport</th>
                        <th className="px-1 py-1 font-normal bg-gray-200 border">Work Mobile</th>
                        <th className="px-1 py-1 font-normal bg-gray-200 border">Work Phone</th>
                        <th className="px-1 py-1 font-normal bg-gray-200 border">Personal Phone</th>
                        <th className="px-1 py-1 font-normal bg-gray-200 border">Personal Email</th>
                        <th className="px-1 py-1 font-normal bg-gray-200 border">Passport No</th>
                        <th className="px-1 py-1 font-normal bg-gray-200 border">Passport Issue Date</th>
                        <th className="px-1 py-1 font-normal bg-gray-200 border">Passport Expiry Date</th>
                        <th className="px-1 py-1 font-normal bg-gray-200 border">Place of Issue</th>
                        <th className="px-1 py-1 font-normal bg-gray-200 border">Country of Issue</th>
                        <th className="px-1 py-1 font-normal bg-gray-200 border">Emirates ID</th>
                        <th className="px-1 py-1 font-normal bg-gray-200 border">EID Expiry</th>
                        <th className="px-1 py-1 font-normal bg-gray-200 border">Visa No</th>
                        <th className="px-1 py-1 font-normal bg-gray-200 border">Visa Expiry</th>
                        <th className="px-1 py-1 font-normal bg-gray-200 border">Insurance No</th>
                        <th className="px-1 py-1 font-normal bg-gray-200 border">Insurance Expiry</th>
                        <th className="px-1 py-1 font-normal bg-gray-200 border">License No</th>
                        <th className="px-1 py-1 font-normal bg-gray-200 border">License Expiry</th>
                        <th className="px-1 py-1 font-normal bg-gray-200 border">Basic Pay</th>
                        <th className="px-1 py-1 font-normal bg-gray-200 border">OT Allowance</th>
                        <th className="px-1 py-1 font-normal bg-gray-200 border">NOT Allowance</th>
                        <th className="px-1 py-1 font-normal bg-gray-200 border">Normal Hrs</th>
                        <th className="px-1 py-1 font-normal bg-gray-200 border">Hourly Wage</th>
                        <th className="px-1 py-1 font-normal bg-gray-200 border">OT Rate</th>
                        <th className="px-1 py-1 font-normal bg-gray-200 border">Special OT Rate</th>
                        <th className="px-1 py-1 font-normal bg-gray-200 border">Active</th>
                        <th className="px-1 py-1 font-normal bg-gray-200 border">Memos</th>
                        <th className="px-1 py-1 font-normal bg-gray-200 border">Notes</th>
                        <th className="px-1 py-1 font-normal bg-gray-200 border">Salary Ac</th>
                        <th className="px-1 py-1 font-normal bg-gray-200 border">Advance Ac</th>
                      </>
                    )}

                    <th className="px-1 py-1 bg-gray-200 border font-normal text-center">Actions</th>
                  </tr>
                </thead>

                <tbody>
                  {records?.map((d, i) => (
                    <tr key={i} className="hover:bg-gray-50">
                      <td className="px-3 py-2 border">{i + 1}</td>
                      <td className="px-3 py-2 border">{d.EmpId}</td>
                      <td className="px-3 py-2 border">{d.AlternateID}</td>
                      <td className="px-3 py-2 border">{d.Status}</td>
                      <td className="px-3 py-2 border">{d.Name}</td>
                      <td className="px-3 py-2 border">{d.JobTitle}</td>
                      <td className="px-3 py-2 border">{d.Division}</td>
                      <td className="px-3 py-2 border">{d.Grade}</td>
                      <td className="px-3 py-2 border">{d.Single}</td>
                      <td className="px-3 py-2 border">{d.Nationality}</td>

                      {Open && (
                        <>
                          <td className="px-3 py-2 border">{d.BankAccountNo}</td>
                          <td className="px-3 py-2 border">{d.BankName}</td>
                          <td className="px-3 py-2 border">{d.AgentID}</td>
                          <td className="px-3 py-2 border">{d.CurrentAddress}</td>
                          <td className="px-3 py-2 border">{d.HomeAddress}</td>
                          <td className="px-3 py-2 border">{d.HomeAirport}</td>
                          <td className="px-3 py-2 border">{d.WorkMobile}</td>
                          <td className="px-3 py-2 border">{d.WorkPhone}</td>
                          <td className="px-3 py-2 border">{d.PersonalPhone}</td>
                          <td className="px-3 py-2 border">{d.PersonalEmail}</td>
                          <td className="px-3 py-2 border">{d.PassportNo}</td>
                          <td className="px-3 py-2 border">{d.PassportIssueDate}</td>
                          <td className="px-3 py-2 border">{d.PassportExpiryDate}</td>
                          <td className="px-3 py-2 border">{d.PassportPlaceofIssue}</td>
                          <td className="px-3 py-2 border">{d.PassportCountryofIssue}</td>
                          <td className="px-3 py-2 border">{d.EmiratesId}</td>
                          <td className="px-3 py-2 border">{d.EmiratesIdExpiryDate}</td>
                          <td className="px-3 py-2 border">{d.VisaNo}</td>
                          <td className="px-3 py-2 border">{d.VisaExpiryDate}</td>
                          <td className="px-3 py-2 border">{d.InsuranceNo}</td>
                          <td className="px-3 py-2 border">{d.InsuranceExpiryDate}</td>
                          <td className="px-3 py-2 border">{d.DrivingLicenceNo}</td>
                          <td className="px-3 py-2 border">{d.DrivingLicenceExpiryDate}</td>
                          <td className="px-3 py-2 border">{d.BasicPay}</td>
                          <td className="px-3 py-2 border">{d.Allowances_OT}</td>
                          <td className="px-3 py-2 border">{d.Allowances_NOT}</td>
                          <td className="px-3 py-2 border">{d.NormalHrs}</td>
                          <td className="px-3 py-2 border">{d.HourlyWage}</td>
                          <td className="px-3 py-2 border">{d.OTrate}</td>
                          <td className="px-3 py-2 border">{d.SplOtRate}</td>
                          <td className="px-3 py-2 border">{d.Active}</td>
                          <td className="px-3 py-2 border">{d.Memos}</td>
                          <td className="px-3 py-2 border">{d.Notes}</td>
                          <td className="px-3 py-2 border">{d.SalaryAc}</td>
                          <td className="px-3 py-2 border">{d.AdvanceAc}</td>
                        </>
                      )}

                      <td className="px-3 py-2 border text-center space-x-2">
                        <button
                          className="bg-green-500 text-white px-2 py-1 rounded-md text-xs hover:bg-green-600"
                          data-bs-toggle="modal"
                          data-bs-target="#staticBackdrop"
                          onClick={() => setPayrollData(d)}
                        >
                          <IoIosAddCircleOutline className="inline-block mr-1" />
                          Add
                        </button>
                        <button
                          className="bg-blue-500 text-white px-2 py-1 rounded-md text-xs hover:bg-blue-600"
                          data-bs-toggle="modal"
                          data-bs-target="#staticBackdropnew"
                          onClick={() => setPayrollData(d)}
                        >
                          <FaEye className="inline-block mr-1" />
                          View
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

            </>
          ) : null}

        </div>
        {
          records ? (<>
            <div className="pagination-div">
              <div className="text-end">
                <nav aria-label="Page navigation example">
                  <ul class="pagination">
                    <li class="page-item">
                      {
                        currentPage !== 1 ? (
                          <button class="page-link" href="#" onClick={prePage}>
                            Previous
                          </button>
                        ) : ''
                      }
                    </li>
                    {numbers.map((n, i) => (
                      <li
                        className={`page-item ${currentPage === n ? "active" : ""
                          }`}
                        key={i}
                      >
                        <button
                          className="page-link"
                          onClick={() => changeCPage(n)}
                          href="#"
                        >
                          {n}
                        </button>
                      </li>
                    ))}

                    <li class="page-item">
                      {
                        currentPage !== numbers[numbers.length - 1] ? (
                          <button class="page-link" href="#" onClick={nextPage}>
                            Next
                          </button>
                        ) : null
                      }
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </>) : null
        }
        <AddPayroll popUpData={popUpData} setpopUpData={setpopUpData} />
        <ViewPayroll popUpData={popUpData} loadPayroll={loadPayroll} setLoadPayroll={setLoadPayroll} setpopUpData={setpopUpData} />

        <div className="table-nodata-img mtd">
          {loader ? (
            <>
              {" "}
              <div className="table-nodata-img">
                <div className="center">
                  <p className="text-center pt-5">
                    Please Wait Loading Data... &nbsp;
                    <FallingLines />
                  </p>
                </div>
              </div>
            </>
          ) : null}
        </div>
      </div>
    </div>
  );
  function prePage() {
    if (currentPage !== firstIndex) {
      SetcurrentPage(currentPage - 1);
    }
  }
  function changeCPage(id) {
    SetcurrentPage(id);
  }

  function nextPage() {
    if (currentPage !== lastIndex) {
      SetcurrentPage(currentPage + 1);
    }
  }
};

export default Payroll;
